<!-- Modernized Counter Section -->
<div class="flow-container">
  <div class="counterup">
    <div class="counter-grid">
      <!-- Students -->
      <a routerLink="/student-information" target="_blank" class="counter-card">
        <app-animated-digits [digit]="student" [duration]="5000"></app-animated-digits>
        <h2>Students</h2>
      </a>

      <!-- Management -->
      <a routerLink="/contact-us" target="_blank" class="counter-card">
        <app-animated-digits [digit]="management" [duration]="5000"></app-animated-digits>
        <h2>Management</h2>
      </a>

      <!-- Staff -->
      <a routerLink="/staff-information" target="_blank" class="counter-card">
        <app-animated-digits [digit]="teachers" [duration]="5000"></app-animated-digits>
        <h2>Staff</h2>
      </a>
    </div>
  </div>
</div>